import React, { useContext, type ReactNode } from "react";
import { useHistory } from "react-router-dom";
import {
  AppPreferencesContext,
  userActionsEnum,
} from "../AppPreferencesProvider";
import { Loader } from "@SeemplicityDev/shared";
import { useTranslation } from "react-i18next";
import "./NoDataSources.scss";

interface NoDataSourcesProps {
  actionSubtitle?: ReactNode;
  isFullPage?: boolean;
  title?: string;
  callback?: () => void;
}

const NoDataSources: React.FC<NoDataSourcesProps> = ({
  actionSubtitle,
  isFullPage = true,
  title = "No Data Sources",
  callback = () => {},
}) => {
  const { isAllowed } = useContext(AppPreferencesContext);
  const { push } = useHistory();
  const { t } = useTranslation();

  return (
    <Loader
      className={"page-empty-state"}
      flexcenter
      center
      largeButtons={isFullPage}
      xlTitle={isFullPage}
      noBackground
      title={t(title)}
      subtitle={
        <div className={"no-data-sources-state"}>
          <span>{t("No Integrations have been set up yet.")}</span>
          <span>{actionSubtitle}</span>
        </div>
      }
      action={
        isAllowed(userActionsEnum.VIEW_DATASOURCES_SETTINGS)
          ? {
              disabled: !isAllowed(userActionsEnum.EDIT_DATASOURCES_SETTINGS),
              label: "Integrate Data Sources",
              tooltip: !isAllowed(userActionsEnum.EDIT_DATASOURCES_SETTINGS)
                ? "Access to this action is restricted to Admins"
                : undefined,
              onClick: () => {
                push(`/settings/integrations/dataSources`);
                callback();
              },
            }
          : undefined
      }
    />
  );
};

export default NoDataSources;
